import type { LlamadaRow } from '@/types/llamadas';

// La decisión de qué expone `useLlamadaCompleta`, en función PURA y no por
// elegancia: la ventana que arregla dura UN render —el que sigue al cambio de
// prop, antes de que corra el efecto—, y un e2e con reintentos no la muestrea.
// Aquí sí se puede probar, incluido el caso que se me escapó: mismo id y OTRA
// versión.
export interface DetalleGuardado {
  id: string;
  clave: string;
  fila: LlamadaRow | null;
}

// La clave se construye desde la fila RECIBIDA y no desde la versión pedida. La
// diferencia importa: si llega el evento v2, el GET devuelve ya v3 y el evento v3
// no ha llegado al navegador, etiquetar por lo pedido daría por fresca una puerta
// v3 al lado de un `id_cliente` y unos partes v2 — mezclar dos versiones sin que
// nada falle. Hallazgo P1 de la cuarta vuelta del gate.
export function _claveDe(id: string, fila: LlamadaRow | null, pedida: string | null): string {
  return `${id}|${fila?.actualizado_en ?? pedida ?? ''}`;
}

export function _exponer(
  id: string | null,
  actualizadoEn: string | null,
  dato: DetalleGuardado | null
): { completa: LlamadaRow | null; fresco: boolean } {
  const clave = id == null ? null : `${id}|${actualizadoEn ?? ''}`;
  return {
    // La conversación tolera una versión vieja de la MISMA llamada: vaciarla en
    // cada UPDATE de Realtime haría parpadear la transcripción.
    completa: dato && dato.id === id ? dato.fila : null,
    // La puerta NO la tolera: exige la versión exacta.
    fresco: dato != null && clave != null && dato.clave === clave,
  };
}
